import { type AlertButton, alertController, loadingController, type AlertInput } from '@ionic/vue'
let loading: HTMLIonLoadingElement

export async function showAlert(header: string, subHeader: string, message: string, buttons: string[] | AlertButton[]): Promise<void> {
  const alert = await alertController.create({
    header: header,
    subHeader: subHeader,
    message: message,
    buttons: buttons
  })

  await alert.present()
}

export async function showAlertWithInputs(header: string, subHeader: string, message: string, buttons: string[] | AlertButton[], inputs: AlertInput[]): Promise<HTMLIonAlertElement> {
  const alert = await alertController.create({
    header: header,
    subHeader: subHeader,
    message: message,
    buttons: buttons,
    inputs: inputs
  })

  await alert.present()
  return alert
}

// export async function askAlert(header: string, subHeader: string, message: string): Promise<void> {
//   const alert = await alertController.create({
//     header: header,
//     subHeader: subHeader,
//     message: message,
//     buttons: [
//       {
//         text: 'Annulla',
//         role: 'cancel',
//         handler: () => {
//           handlerMessage.value = 'Alert canceled'
//         }
//       },
//       {
//         text: 'Ok',
//         role: 'confirm',
//         handler: () => {
//           handlerMessage.value = 'Alert confirmed'
//         }
//       }
//     ]
//   })

//   await alert.present()
// }

export async function showLoader(message: string, duration: number | undefined): Promise<void> {
  loading = await loadingController.create({
    message: message,
    duration: duration ?? 3000,
    animated: true,
    keyboardClose: true
  })

  await loading.present()
}

export async function dismissLoader(): Promise<void> {
  await loading.dismiss()
}
